import { createContext, useContext } from 'react';

export type AdminRestaurant = { food_maker_key: string; display_name: string };
export type AdminAccessResponse = {
  restaurants: AdminRestaurant[];
  can_view_food_makers_status: boolean;
};
export type AdminAccessStatus = 'idle' | 'loading' | 'ready' | 'error';
export type AdminAccessContextType = {
  status: AdminAccessStatus;
  access: AdminAccessResponse | null;
  error: string | null;
  refresh: () => Promise<void>;
  canManage: (foodMaker: string) => boolean;
};

const AdminAccessContext = createContext<AdminAccessContextType | null>(null);
export const useAdminAccess = () => useContext(AdminAccessContext);
export default AdminAccessContext;

/** Rejects incomplete or malformed grants so missing fields cannot imply access. */
export function parseAdminAccessResponse(payload: unknown): AdminAccessResponse {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error('Invalid permission response.');
  }
  const value = payload as Record<string, unknown>;
  if (!Array.isArray(value.restaurants) || typeof value.can_view_food_makers_status !== 'boolean'
    || !value.restaurants.every((item): item is AdminRestaurant =>
      !!item && typeof item === 'object' && typeof item.food_maker_key === 'string'
      && item.food_maker_key.trim().length > 0 && typeof item.display_name === 'string')) {
    throw new Error('Invalid permission response.');
  }
  return {
    restaurants: value.restaurants,
    can_view_food_makers_status: value.can_view_food_makers_status,
  };
}
